import type { PredictionMarketWithProbability } from "@roman/shared/types/PredictionMarket";
// import { env } from "@roman/shared/config/env";
import { Helmet } from "react-helmet-async";

interface PredictionMarketOGPProps {
  market: PredictionMarketWithProbability;
}

export const PredictionMarketOGP: React.FC<PredictionMarketOGPProps> = ({ market }) => {
  const currentUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}/prediction-market/details/${market.id}`
      : `https://thumba.jp/prediction-market/details/${market.id}`;

  const title = market.title;
  const description = market.description;

  // TODO: Replace with server-side generated OGP image
  // https://app.asana.com/1/1206681304008283/project/1209417177573995/task/1210702917141981
  // Implement server-side generated OGP image
  // let apiUrl = env.API_URL;
  // const ogImageUrl = `${apiUrl}/og-image/prediction-market/${market.id}`

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph meta tags */}
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {/* <meta property="og:image" content={ogImageUrl} /> */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="サンバ" />

      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {/* <meta name="twitter:image" content={ogImageUrl} /> */}
      <meta name="twitter:site" content="@thumba_jp" />

      {/* Additional meta tags for better sharing */}
      <meta name="twitter:image:alt" content={market.title} />
      <meta property="og:image:alt" content={market.title} />
    </Helmet>
  );
};
